import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Box } from "@chakra-ui/react"
import { useAuth } from "../auth/AuthProvider"
import { UserManager } from "../components/admin/UserManager"
import { OrganizationManagement } from "./admin/OrganizationManagement"
import { Tabs } from "@chakra-ui/react"
import { GlobalFeaturesManager } from "../components/admin/GlobalFeaturesManager"
import { InvitationManager } from "../components/admin/InvitationManager"
import { AlertTemplateManager } from "../components/admin/AlertTemplateManager"

/**
 * Admin Settings Page
 *
 * Full-page view for admin-only settings accessible at /settings/admin
 * Includes tenant management, user management, feature assignment, limits configuration, and alert templates
 */
export const AdminSettingsPage = () => {
  const { user } = useAuth()
  const navigate = useNavigate()

  // Redirect non-admin users
  useEffect(() => {
    if (user && user.role !== "admin") {
      console.warn("Non-admin user attempted to access admin settings")
      navigate("/", { replace: true })
    }
  }, [user, navigate])

  // Show nothing while checking auth (useEffect will redirect)
  if (!user || user.role !== "admin") {
    return null
  }

  return (
    <Box p={6}>
      <Tabs.Root defaultValue="organizations" variant={"primary" as any}>
        <Tabs.List>
          <Tabs.Trigger value="features">Features</Tabs.Trigger>
          <Tabs.Trigger value="alert-templates">Alerts</Tabs.Trigger>
          <Tabs.Trigger value="invitations">Invitations</Tabs.Trigger>
          <Tabs.Trigger value="users">Users</Tabs.Trigger>
          <Tabs.Trigger value="organizations">Organisations</Tabs.Trigger>
        </Tabs.List>

        <Box mt={4}>
          <Tabs.Content value="organizations">
            <OrganizationManagement />
          </Tabs.Content>

          <Tabs.Content value="users">
            <UserManager />
          </Tabs.Content>

          <Tabs.Content value="invitations">
            <InvitationManager />
          </Tabs.Content>

          <Tabs.Content value="features">
            <GlobalFeaturesManager />
          </Tabs.Content>

          <Tabs.Content value="alert-templates">
            <AlertTemplateManager />
          </Tabs.Content>
        </Box>
      </Tabs.Root>
    </Box>
  )
}
